export const InvoicesIcon = (props) => {
  // const { className } = props;

  return <h5 style={{ marginBottom: 0 }}>I</h5>;
};
